import useResourceList from './useResourceList';
import mutationFactory from './mutationFactory';

import api from '..';

export const useFlashInterviewsList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList(
    { name: 'flash-interviews', api: api.flashInterviews },
    queryVariables,
    queryConfig,
  );

  return {
    flashInterviews: queryResult.resolvedData.data,
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'flash-interviews' });

export const useUpdateFlashInterview = createMutation(api.flashInterviews.update);

export const useApproveFlashInterview = createMutation(api.flashInterviews.approve);

export const useRejectFlashInterview = createMutation(api.flashInterviews.reject);
